<script lang="ts">
  import Button from "./Button.svelte";
  import Typography from "./Typography.svelte";
  import { TypographyType } from "../lib/constants/typographyMap";
  import { getCopy } from "../lib/stores/copy";
  import Close from "../assets/icons/close.svg";
  import Accordion from "./Accordion.svelte";
  import Toggle from "./Toggle.svelte";
  import * as cookiesHelper from "../lib/helpers/cookies";
  import { createEventDispatcher } from "svelte";

  export let isVisible = false;

  const dispatch = createEventDispatcher();

  const close = () => {
    isVisible = false;
  };

  let consent = {
    essential: true,
    analytics_storage: true,
    functionality_storage: true,
    ad_storage: true
  };

  const save = () => {
    cookiesHelper.savePreferences(consent);
    dispatch("save");
  };

  const accept = () => {
    consent = {
      essential: true,
      analytics_storage: true,
      functionality_storage: true,
      ad_storage: true
    };
    save();
  };

  const deny = () => {
    cookiesHelper.deny();
    dispatch("save");
  };

  $: copy = $getCopy("gdpr") as Record<string, string>;
</script>

<!-- eslint-disable @typescript-eslint/no-unsafe-return -->
<!-- eslint-disable @typescript-eslint/no-unsafe-assignment -->
{#if isVisible}
  <div
    class="fixed block lg:flex top-0 left-0 w-full h-full justify-center z-10 bg-black bg-opacity-30 overflow-y-auto">
    <div class="flex flex-col mt-4 lg:mt-0 lg:w-1/2 mx-4 lg:mx-0 bg-white z-10 relative rounded-3xl h-fit lg:mt-8">
      <button class="absolute right-4 top-4 h-6 w-6" aria-label="close" on:click={close}>
        <img src={Close} alt="Close" />
      </button>
      <div class="py-8 px-4 lg:p-8">
        <div class="mb-3 text-[--color-grayscale-black]">
          <Typography mobile={TypographyType.Headline1} desktop={TypographyType.Headline1} copy={copy.headerCopy} />
        </div>
        <div class="mb-6">
          <Typography
            mobile={TypographyType.Body1Medium}
            desktop={TypographyType.Body1Medium}
            copy={copy.subHeaderCopy} />
        </div>
        <div class="flex gap-4">
          <Button secondary on:click={deny}>{copy.bannerDenyCopy}</Button>
          <Button primary on:click={accept}>{copy.bannerAcceptCopy}</Button>
        </div>
        <div class="mt-6 mb-3 text-[--color-grayscale-black]">
          <Typography
            mobile={TypographyType.Headline3}
            desktop={TypographyType.Headline3}
            copy={copy.categoryHeaderCopy} />
        </div>
        <div class="mb-6">
          <Typography
            mobile={TypographyType.Body1Medium}
            desktop={TypographyType.Body1Medium}
            copy={copy.categoryDescriptionCopy} />
        </div>
        <Accordion>
          <div slot="head" class="flex items-center text-[--color-grayscale-black] justify-between w-full">
            <Typography
              mobile={TypographyType.Body1Medium}
              desktop={TypographyType.Body1Medium}
              copy={copy.essentialHeaderCopy} />
            <div class="rounded-full bg-[--color-green-50] text-[--color-green-80] px-2">
              <Typography
                mobile={TypographyType.Body1Medium}
                desktop={TypographyType.Body1Medium}
                copy={copy.alwaysActiveCopy} />
            </div>
          </div>
          <div slot="details">
            <Typography
              mobile={TypographyType.Body1Medium}
              desktop={TypographyType.Body1Medium}
              copy={copy.essentialDescriptionCopy} />
          </div>
        </Accordion>
        <Accordion>
          <div slot="head" class="flex items-center text-[--color-grayscale-black] w-full justify-between">
            <Typography
              mobile={TypographyType.Body1Medium}
              desktop={TypographyType.Body1Medium}
              copy={copy.performanceHeaderCopy} />
            <Toggle
              checked={consent.analytics_storage}
              key="performance"
              on:change={(e) => (consent.analytics_storage = e.detail)} />
          </div>
          <div slot="details">
            <Typography
              mobile={TypographyType.Body1Medium}
              desktop={TypographyType.Body1Medium}
              copy={copy.performanceDescriptionCopy} />
          </div>
        </Accordion>
        <Accordion>
          <div slot="head" class="flex items-center text-[--color-grayscale-black] w-full justify-between">
            <Typography
              mobile={TypographyType.Body1Medium}
              desktop={TypographyType.Body1Medium}
              copy={copy.functionalHeaderCopy} />
            <Toggle
              checked={consent.functionality_storage}
              key="functional"
              on:change={(e) => (consent.functionality_storage = e.detail)} />
          </div>
          <div slot="details">
            <Typography
              mobile={TypographyType.Body1Medium}
              desktop={TypographyType.Body1Medium}
              copy={copy.functionalDescriptionCopy} />
          </div>
        </Accordion>
        <Accordion>
          <div slot="head" class="flex items-center text-[--color-grayscale-black] w-full justify-between">
            <Typography
              mobile={TypographyType.Body1Medium}
              desktop={TypographyType.Body1Medium}
              copy={copy.targetingHeaderCopy} />
            <Toggle checked={consent.ad_storage} key="targeting" on:change={(e) => (consent.ad_storage = e.detail)} />
          </div>
          <div slot="details">
            <Typography
              mobile={TypographyType.Body1Medium}
              desktop={TypographyType.Body1Medium}
              copy={copy.targetingDescriptionCopy} />
          </div>
        </Accordion>
        <div class="flex w-full justify-end">
          <Button primary class="w-48" on:click={save}>{copy.savePreferencesCopy}</Button>
        </div>
      </div>
    </div>
  </div>
{/if}

<style>
</style>
